<template>
  <div class="main-content blackListComponent">

    <sweet-modal ref="phoneModal" overlay-theme="dark">
      <phoneBlackListEdit
        :newRecord="newRecord"
        :onCancel="onCancelModal"
        :updateRecordList="updateRecord"
      />
    </sweet-modal>

    <div class="card">
      <div class="card-header">
        <h5>Поиск по черному списку телефонов</h5>
      </div>
      <form action="" @submit="search">
        <div class="card-body">
          <div class="flex">
            <div class="form-group">
              <label for="">Номер телефона</label>
              <input v-model="phoneSearch" type="text" placeholder="+7 915 000 00 00" class="form-control">
            </div>
          </div>
        </div>
        <div class="card-footer text-right">
          <button type="button" @click="openModal" class="btn ladda-button btn-warning">Добавить в черный список</button>
          <vue-ladda type="submit" button-class="btn btn-info"
                     data-style="zoom-in"
                     :loading="searchLoading">Поиск
          </vue-ladda>
        </div>
      </form>
    </div>

    <pulse-loader :loading="searchLoading" :color="color" class="text-center"/>

    <div v-if="records && !searchLoading" class="card">
      <div class="card-body">
        <div>
          <table class="table table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Номер</th>
              <th>Комментарий</th>
              <th>Добавлено</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, index) in records" :key="index">
              <td>{{ index + 1 }}</td>
              <td><strong>{{ record.phone_num }}</strong></td>
              <td>
                <template v-if="record.comments">
                  <div class="p-2">
                    <div class="comment" v-for="(comment, index) in record.comments" :key="`comment_${index}`">
                      <p>{{ comment.text }}</p>
                      <p class="author">{{ comment.user_name }}: {{ comment.created_at }}</p>
                    </div>
                  </div>
                </template>
              </td>
              <td>
                <p class="m-0">{{ record.created_at }}</p>
                <span v-bind:class="{badge: true, 'badge-primary':record.is_active, 'badge-dark':!record.is_active}">{{ record.is_active ? 'Активен' : 'Не активен' }}</span>
              </td>
              <td>
                <button @click="openModal(record)" class="btn btn-info btn-xs">
                  <i class="icon-fa icon-fa-edit"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="row" v-if="paginator">
          <div class="col-md-12">
            Всего записей: <strong>{{ paginator.total }}</strong>
            <div class="pull-right">
              <paginate
                v-model="currentPage"
                :page-count="paginator.last_page"
                :page-range="3"
                :margin-pages="2"
                :click-handler="search"
                :prev-text="'&laquo'"
                :next-text="'&raquo'"
                :container-class="'pagination'"
                :prev-class="'page-item'"
                :prev-link-class="'page-link'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :next-class="'page-item'"
                :next-link-class="'page-link'"
                :active-class="'active green_btn'">
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import api from '@/api'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import {SweetModal} from 'sweet-modal-vue'
import Paginate from 'vuejs-paginate'
import phoneBlackListEdit from "../../components/clients/phoneBlackListEdit";

export default {
  components: {
    VueLadda,
    SweetModal,
    Paginate,
    phoneBlackListEdit,
  },
  data() {
    return {
      paginator: null,
      currentPage: 1,
      color: this.$constants.LOADING_COLOR,
      searchLoading: false,
      saveLoading: false,
      phoneSearch: null,
      records: null,
      newRecord: {},
    }
  },
  created() {
    this.search();
  },
  methods: {
    updateRecord(record) {
      if (record && record.id) {
        this.records = this.records.map((r) => {
          if (r.id == record.id) {
            r = record;
          }
          return r;
        });
      }
    },
    async openModal(record = null) {
      this.newRecord = {};
      if (record) {
        this.newRecord = record;
      }
      this.$refs.phoneModal.open();
    },
    onCancelModal() {
      this.newRecord = {};
      this.$refs.phoneModal.close();
    },
    async search(e) {
      if (e && !Number.isInteger(e)) {
        this.currentPage = 1;
        e.preventDefault();
      }
      this.searchLoading = true;
      this.records = null;
      let {data: res_data} = await api.post('/clients/blacklist', {
        type: 'search',
        page: this.currentPage,
        phoneSearch: this.phoneSearch
      });

      if (res_data.success) {
        this.paginator = null;
        const {data, ...pagination} = res_data.records;
        this.paginator = pagination;
        this.records = data;
      } else {
        this.Toast.fire({
          type: 'warning',
          title: data.message || 'Ошибка сервера'
        });
      }

      this.searchLoading = false;
    }
  }
}
</script>

<style>
.blackListComponent .sweet-modal {
  background-color: #fdfdfd;
}
</style>

<style scoped>
.comment {
  border-bottom: 1px solid lightgray;
}

.comment p {
  margin-bottom: 0;
}

.comment .author {
  text-align: right;
  font-size: 12px;
}
</style>
